/**
* This file was @generated using pocketbase-typegen
*/

import type PocketBase from 'pocketbase'
import type { RecordService } from 'pocketbase'

export enum Collections {
	Authorigins = "_authOrigins",
	Externalauths = "_externalAuths",
	Mfas = "_mfas",
	Otps = "_otps",
	Superusers = "_superusers",
	Config = "config",
	DiscgolfCourse = "discgolf_course",
	DiscgolfInfos = "discgolf_infos",
	Feedback = "feedback",
	Foods = "foods",
	Helperjobs = "helperjobs",
	HelperjobsView = "helperjobs_view",
	Images = "images",
	Items = "items",
	Jingles = "jingles",
	LiveScores = "live_scores",
	Locations = "locations",
	LostItemClaims = "lost_item_claims",
	LostItems = "lost_items",
	Matchups = "matchups",
	Notifications = "notifications",
	Orders = "orders",
	PageViews = "page_views",
	Players = "players",
	PoolElements = "pool_elements",
	PoolFixtures = "pool_fixtures",
	Pools = "pools",
	RequestsForBookerRole = "requests_for_booker_role",
	Roles = "roles",
	SettlementOverview = "settlement_overview",
	Shotracer = "shotracer",
	Slots = "slots",
	SlottedMatchups = "slotted_matchups",
	Spirit = "spirit",
	StatsPlaylists = "stats_playlists",
	TeamRegistrations = "team_registrations",
	Teams = "teams",
	Theme = "theme",
	Timelines = "timelines",
	TournamentInfos = "tournament_infos",
	TournamentPhases = "tournament_phases",
	Tournaments = "tournaments",
	Users = "users",
}

// Alias types for improved usability
export type IsoDateString = string
export type RecordIdString = string
export type HTMLString = string

type ExpandType<T> = unknown extends T
	? T extends unknown
		? { expand?: unknown }
		: { expand: T }
	: { expand: T }

// System fields
export type BaseSystemFields<T = unknown> = {
	id: RecordIdString
	collectionId: string
	collectionName: Collections
} & ExpandType<T>

export type AuthSystemFields<T = unknown> = {
	email: string
	emailVisibility: boolean
	username: string
	verified: boolean
} & BaseSystemFields<T>

// Record types for each collection

export type AuthoriginsRecord = {
	collectionRef: string
	created?: IsoDateString
	fingerprint: string
	id: string
	recordRef: string
	updated?: IsoDateString
}

export type ExternalauthsRecord = {
	collectionRef: string
	created?: IsoDateString
	id: string
	provider: string
	providerId: string
	recordRef: string
	updated?: IsoDateString
}

export type MfasRecord = {
	collectionRef: string
	created?: IsoDateString
	id: string
	method: string
	recordRef: string
	updated?: IsoDateString
}

export type OtpsRecord = {
	collectionRef: string
	created?: IsoDateString
	id: string
	password: string
	recordRef: string
	sentTo?: string
	updated?: IsoDateString
}

export type SuperusersRecord = {
	created?: IsoDateString
	email: string
	emailVisibility?: boolean
	id: string
	password: string
	tokenKey: string
	updated?: IsoDateString
	verified?: boolean
}

export type ConfigRecord = {
	arsludendi_registration_pw?: string
	created?: IsoDateString
	helperjobs_entries_active?: boolean
	id: string
	schedule_initialized?: boolean
	shotracer_active?: boolean
	soundcloud_playlist_url?: string
	spirit_entry_active?: boolean
	spirit_entry_message?: string
	team_registration_active?: boolean
	teammanager_settlement_active?: boolean
	teammanager_settlement_message?: string
	teammanager_spirit_overview_active?: boolean
	teammanager_spirit_overview_message?: string
	universe_point_tracking_active?: boolean
	updated?: IsoDateString
	user_login_active?: boolean
	user_login_message?: string
	user_registration_active?: boolean
	user_registration_message?: string
}

export type DiscgolfCourseRecord = {
	created?: IsoDateString
	id: string
	image?: string
	number?: number
	updated?: IsoDateString
}

export type DiscgolfInfosRecord = {
	created?: IsoDateString
	id: string
	order?: number
	text?: HTMLString
	title?: string
	updated?: IsoDateString
}

export type FeedbackRecord = {
	comments?: string
	created?: IsoDateString
	design?: number
	functionality?: number
	id: string
	informationquality?: number
	rating?: number
	really_bad?: string
	really_good?: string
	updated?: IsoDateString
	usability?: number
	user_roles?: string
}

export enum FoodsCategoryOptions {
	"Salad" = "Salad",
	"Cake" = "Cake",
	"Breakfast" = "Breakfast",
}

export enum FoodsDayOptions {
	"Saturday" = "Saturday",
	"Sunday" = "Sunday",
}
export type FoodsRecord = {
	category?: FoodsCategoryOptions
	created?: IsoDateString
	day?: FoodsDayOptions
	id: string
	name?: string
	tournament: RecordIdString
	updated?: IsoDateString
	user?: RecordIdString
}

export enum HelperjobsCategoryOptions {
	"Drinks" = "Drinks",
	"Food" = "Food",
	"Maintenance" = "Maintenance",
	"General" = "General",
	"Party" = "Party",
}
export type HelperjobsRecord = {
	all?: boolean
	category?: HelperjobsCategoryOptions
	chiefs?: RecordIdString[]
	count?: number
	created?: IsoDateString
	description?: string
	end?: IsoDateString
	id: string
	name?: string
	persons?: RecordIdString[]
	score?: number
	start?: IsoDateString
	tournament: RecordIdString
	updated?: IsoDateString
}

export enum HelperjobsViewCategoryOptions {
	"Drinks" = "Drinks",
	"Food" = "Food",
	"Maintenance" = "Maintenance",
	"General" = "General",
	"Party" = "Party",
}
export type HelperjobsViewRecord<Tchief_names_array = unknown, Tperson_names_array = unknown> = {
	all?: boolean
	category?: HelperjobsViewCategoryOptions
	chief_names_array?: null | Tchief_names_array
	count?: number
	description?: string
	end?: IsoDateString
	id: string
	name?: string
	person_names_array?: null | Tperson_names_array
	persons?: RecordIdString[]
	score?: number
	start?: IsoDateString
	tournament: RecordIdString
}

export type ImagesRecord = {
	barcode?: string
	big_map?: string
	created?: IsoDateString
	id: string
	small_map?: string
	updated?: IsoDateString
}

export type ItemsRecord = {
	created?: IsoDateString
	icon?: string
	id: string
	locations?: RecordIdString[]
	name?: string
	price?: number
	tournament: RecordIdString
	updated?: IsoDateString
}

export enum JinglesTypeOptions {
	"start" = "start",
	"end" = "end",
}
export type JinglesRecord = {
	created?: IsoDateString
	disabled?: boolean
	file: string
	id: string
	name: string
	offset?: number
	tournament: RecordIdString
	type: JinglesTypeOptions
	updated?: IsoDateString
}

export type LiveScoresRecord = {
	created?: IsoDateString
	id: string
	matchup: RecordIdString
	score_a?: number
	score_b?: number
	universe?: boolean
	updated?: IsoDateString
	user: RecordIdString
}

export type LocationsRecord = {
	created?: IsoDateString
	id: string
	name?: string
	tournament: RecordIdString
	updated?: IsoDateString
}

export type LostItemClaimsRecord = {
	created?: IsoDateString
	email?: string
	id: string
	item: RecordIdString
	message?: string
	name: string
	phone?: string
	team?: RecordIdString
	updated?: IsoDateString
	user: RecordIdString
}

export enum LostItemsStatusOptions {
	"open" = "open",
	"claimed" = "claimed",
	"resolved" = "resolved",
}
export type LostItemsRecord = {
	created?: IsoDateString
	created_by?: RecordIdString
	description?: string
	id: string
	label: string
	photo?: string
	status: LostItemsStatusOptions
	tournament: RecordIdString
	updated?: IsoDateString
}

export type MatchupsRecord = {
	created?: IsoDateString
	fixture?: RecordIdString
	id: string
	score_a?: number
	score_b?: number
	slot?: RecordIdString
	team_a?: RecordIdString
	team_b?: RecordIdString
	tournament: RecordIdString
	universe?: boolean
	updated?: IsoDateString
}

export enum NotificationsSeverityOptions {
	"success" = "success",
	"info" = "info",
	"warn" = "warn",
	"error" = "error",
	"secondary" = "secondary",
	"contrast" = "contrast",
}
export type NotificationsRecord = {
	active?: boolean
	closable?: boolean
	created?: IsoDateString
	id: string
	severity?: NotificationsSeverityOptions
	text?: HTMLString
	updated?: IsoDateString
}

export type OrdersRecord = {
	booker?: RecordIdString
	count: number
	created?: IsoDateString
	deletetime?: IsoDateString
	id: string
	item: RecordIdString
	player: RecordIdString
	sum?: number
	tournament: RecordIdString
	updated?: IsoDateString
}

export type PageViewsRecord = {
	created?: IsoDateString
	id: string
	navigation_type?: string
	page: string
	session_id?: string
	updated?: IsoDateString
	url_full?: string
	user?: RecordIdString
	user_agent_original?: string
}

export type PlayersRecord = {
	booking_id: number
	created?: IsoDateString
	id: string
	name: string
	photo?: string
	team: RecordIdString
	tournament: RecordIdString
	updated?: IsoDateString
}

export type PoolElementsRecord<Tsource = unknown> = {
	created?: IsoDateString
	id: string
	pool: RecordIdString
	seeding?: number
	source?: null | Tsource
	team?: RecordIdString
	updated?: IsoDateString
}

export type PoolFixturesRecord<Tteam_a_source = unknown, Tteam_b_source = unknown> = {
	created?: IsoDateString
	id: string
	label_a?: string
	label_b?: string
	pool: RecordIdString
	round?: number
	team_a_source: null | Tteam_a_source
	team_b_source: null | Tteam_b_source
	tournament?: RecordIdString
	updated?: IsoDateString
}

export enum PoolsDivisionOptions {
	"mixed" = "mixed",
	"open" = "open",
	"women" = "women",
}
export type PoolsRecord = {
	color: string
	created?: IsoDateString
	division: PoolsDivisionOptions
	id: string
	name: string
	size?: number
	tournament: RecordIdString
	tournament_phase?: RecordIdString
	updated?: IsoDateString
}

export type RequestsForBookerRoleRecord = {
	created?: IsoDateString
	done?: boolean
	id: string
	updated?: IsoDateString
	user?: RecordIdString
}

export enum RolesRolesOptions {
	"admin" = "admin",
	"booker" = "booker",
	"scorekeeper" = "scorekeeper",
	"stats" = "stats",
	"teammanager" = "teammanager",
	"worker" = "worker",
	"lostfound" = "lostfound",
}
export type RolesRecord = {
	created?: IsoDateString
	id: string
	roles?: RolesRolesOptions[]
	updated?: IsoDateString
	user?: RecordIdString
}

export type SettlementOverviewRecord<Tall_orders_sum = unknown, Tplayer_total = unknown, Tplayersfee = unknown> = {
	all_orders_sum?: null | Tall_orders_sum
	id: string
	name: string
	player_total?: null | Tplayer_total
	playersfee?: null | Tplayersfee
	team: RecordIdString
	tournament: RecordIdString
}

export enum ShotracerModeOptions {
	"solo" = "solo",
	"team" = "team",
}

export enum ShotracerShotracerOptions {
	"yellow" = "yellow",
	"pink" = "pink",
}
export type ShotracerRecord = {
	created?: IsoDateString
	id: string
	mode?: ShotracerModeOptions
	name?: string
	shotracer?: ShotracerShotracerOptions
	time?: number
	updated?: IsoDateString
}

export type SlotsRecord = {
	created?: IsoDateString
	duration: number
	field: number
	id: string
	placeholder_a?: string
	placeholder_b?: string
	pool?: RecordIdString
	start: number
	tournament: RecordIdString
	updated?: IsoDateString
}

export type SlottedMatchupsRecord = {
	duration: number
	field: number
	id: string
	pool?: RecordIdString
	score_a?: number
	score_b?: number
	slot_id?: RecordIdString
	start: number
	team_a?: RecordIdString
	team_b?: RecordIdString
	tournament: RecordIdString
	universe?: boolean
}

export type SpiritRecord = {
	comment?: string
	communication?: number
	created?: IsoDateString
	fair_mindedness?: number
	fouls_and_body_contact?: number
	id: string
	opponent: RecordIdString
	positive_attitude_and_self_control?: number
	rules_knowledge_and_use?: number
	team: RecordIdString
	total_score?: number
	tournament: RecordIdString
	updated?: IsoDateString
}

export type StatsPlaylistsRecord<Tconfig = unknown> = {
	config: null | Tconfig
	created?: IsoDateString
	id: string
	name: string
	updated?: IsoDateString
	version: number
}

export enum TeamRegistrationsDivisionOptions {
	"mixed" = "mixed",
	"open" = "open",
	"women" = "women",
}
export type TeamRegistrationsRecord = {
	competition_level?: number
	contact_person?: string
	created?: IsoDateString
	division?: TeamRegistrationsDivisionOptions
	email?: string
	id: string
	party_level?: number
	reason?: string
	team_name?: string
	town?: string
	updated?: IsoDateString
}

export enum TeamsDivisionOptions {
	"mixed" = "mixed",
	"open" = "open",
	"women" = "women",
}
export type TeamsRecord = {
	country?: string
	country_code?: string
	created?: IsoDateString
	division: TeamsDivisionOptions
	id: string
	name: string
	teammanager?: RecordIdString[]
	tournament: RecordIdString
	updated?: IsoDateString
}

export type ThemeRecord = {
	background: string
	border: string
	id: string
	primary: string
	text: string
	text_secondary: string
}

export type TimelinesRecord = {
	created?: IsoDateString
	end?: string
	id: string
	start?: IsoDateString
	text?: HTMLString
	title?: string
	tournament: RecordIdString
	updated?: IsoDateString
}

export type TournamentInfosRecord = {
	created?: IsoDateString
	id: string
	order?: number
	text?: HTMLString
	title?: string
	tournament: RecordIdString
	updated?: IsoDateString
}

export enum TournamentPhasesDivisionOptions {
	"mixed" = "mixed",
	"open" = "open",
	"women" = "women",
}

export enum TournamentPhasesTypeOptions {
	"pool_play" = "pool_play",
	"bracket" = "bracket",
	"placement" = "placement",
}
export type TournamentPhasesRecord = {
	created?: IsoDateString
	division: TournamentPhasesDivisionOptions
	id: string
	name: string
	parent_phase?: RecordIdString
	rank?: number
	tournament: RecordIdString
	type?: TournamentPhasesTypeOptions
	updated?: IsoDateString
}

export enum TournamentsStatusOptions {
	"draft" = "draft",
	"scheduled" = "scheduled",
	"live" = "live",
	"archived" = "archived",
}
export type TournamentsRecord<Tdivision_rotation_pattern = unknown, Tdivisions = unknown, Ttiebreak_rules = unknown> = {
	created?: IsoDateString
	default_break_minutes?: number
	default_game_duration_minutes?: number
	division_rotation_pattern?: null | Tdivision_rotation_pattern
	divisions?: null | Tdivisions
	ends_at?: IsoDateString
	id: string
	is_active?: boolean
	name: string
	num_fields?: number
	playersfee?: number
	starts_at?: IsoDateString
	status: TournamentsStatusOptions
	tiebreak_rules?: null | Ttiebreak_rules
	updated?: IsoDateString
	year: number
}

export type UsersRecord = {
	avatar?: string
	created?: IsoDateString
	email: string
	emailVisibility?: boolean
	id: string
	name?: string
	password: string
	player?: RecordIdString
	tokenKey: string
	updated?: IsoDateString
	username: string
	verified?: boolean
}

// Response types include system fields and match responses from the PocketBase API
export type AuthoriginsResponse<Texpand = unknown> = Required<AuthoriginsRecord> & BaseSystemFields<Texpand>
export type ExternalauthsResponse<Texpand = unknown> = Required<ExternalauthsRecord> & BaseSystemFields<Texpand>
export type MfasResponse<Texpand = unknown> = Required<MfasRecord> & BaseSystemFields<Texpand>
export type OtpsResponse<Texpand = unknown> = Required<OtpsRecord> & BaseSystemFields<Texpand>
export type SuperusersResponse<Texpand = unknown> = Required<SuperusersRecord> & AuthSystemFields<Texpand>
export type ConfigResponse<Texpand = unknown> = Required<ConfigRecord> & BaseSystemFields<Texpand>
export type DiscgolfCourseResponse<Texpand = unknown> = Required<DiscgolfCourseRecord> & BaseSystemFields<Texpand>
export type DiscgolfInfosResponse<Texpand = unknown> = Required<DiscgolfInfosRecord> & BaseSystemFields<Texpand>
export type FeedbackResponse<Texpand = unknown> = Required<FeedbackRecord> & BaseSystemFields<Texpand>
export type FoodsResponse<Texpand = unknown> = Required<FoodsRecord> & BaseSystemFields<Texpand>
export type HelperjobsResponse<Texpand = unknown> = Required<HelperjobsRecord> & BaseSystemFields<Texpand>
export type HelperjobsViewResponse<Tchief_names_array = unknown, Tperson_names_array = unknown, Texpand = unknown> = Required<HelperjobsViewRecord<Tchief_names_array, Tperson_names_array>> & BaseSystemFields<Texpand>
export type ImagesResponse<Texpand = unknown> = Required<ImagesRecord> & BaseSystemFields<Texpand>
export type ItemsResponse<Texpand = unknown> = Required<ItemsRecord> & BaseSystemFields<Texpand>
export type JinglesResponse<Texpand = unknown> = Required<JinglesRecord> & BaseSystemFields<Texpand>
export type LiveScoresResponse<Texpand = unknown> = Required<LiveScoresRecord> & BaseSystemFields<Texpand>
export type LocationsResponse<Texpand = unknown> = Required<LocationsRecord> & BaseSystemFields<Texpand>
export type LostItemClaimsResponse<Texpand = unknown> = Required<LostItemClaimsRecord> & BaseSystemFields<Texpand>
export type LostItemsResponse<Texpand = unknown> = Required<LostItemsRecord> & BaseSystemFields<Texpand>
export type MatchupsResponse<Texpand = unknown> = Required<MatchupsRecord> & BaseSystemFields<Texpand>
export type NotificationsResponse<Texpand = unknown> = Required<NotificationsRecord> & BaseSystemFields<Texpand>
export type OrdersResponse<Texpand = unknown> = Required<OrdersRecord> & BaseSystemFields<Texpand>
export type PageViewsResponse<Texpand = unknown> = Required<PageViewsRecord> & BaseSystemFields<Texpand>
export type PlayersResponse<Texpand = unknown> = Required<PlayersRecord> & BaseSystemFields<Texpand>
export type PoolElementsResponse<Tsource = unknown, Texpand = unknown> = Required<PoolElementsRecord<Tsource>> & BaseSystemFields<Texpand>
export type PoolFixturesResponse<Tteam_a_source = unknown, Tteam_b_source = unknown, Texpand = unknown> = Required<PoolFixturesRecord<Tteam_a_source, Tteam_b_source>> & BaseSystemFields<Texpand>
export type PoolsResponse<Texpand = unknown> = Required<PoolsRecord> & BaseSystemFields<Texpand>
export type RequestsForBookerRoleResponse<Texpand = unknown> = Required<RequestsForBookerRoleRecord> & BaseSystemFields<Texpand>
export type RolesResponse<Texpand = unknown> = Required<RolesRecord> & BaseSystemFields<Texpand>
export type SettlementOverviewResponse<Tall_orders_sum = unknown, Tplayer_total = unknown, Tplayersfee = unknown, Texpand = unknown> = Required<SettlementOverviewRecord<Tall_orders_sum, Tplayer_total, Tplayersfee>> & BaseSystemFields<Texpand>
export type ShotracerResponse<Texpand = unknown> = Required<ShotracerRecord> & BaseSystemFields<Texpand>
export type SlotsResponse<Texpand = unknown> = Required<SlotsRecord> & BaseSystemFields<Texpand>
export type SlottedMatchupsResponse<Texpand = unknown> = Required<SlottedMatchupsRecord> & BaseSystemFields<Texpand>
export type SpiritResponse<Texpand = unknown> = Required<SpiritRecord> & BaseSystemFields<Texpand>
export type StatsPlaylistsResponse<Tconfig = unknown, Texpand = unknown> = Required<StatsPlaylistsRecord<Tconfig>> & BaseSystemFields<Texpand>
export type TeamRegistrationsResponse<Texpand = unknown> = Required<TeamRegistrationsRecord> & BaseSystemFields<Texpand>
export type TeamsResponse<Texpand = unknown> = Required<TeamsRecord> & BaseSystemFields<Texpand>
export type ThemeResponse<Texpand = unknown> = Required<ThemeRecord> & BaseSystemFields<Texpand>
export type TimelinesResponse<Texpand = unknown> = Required<TimelinesRecord> & BaseSystemFields<Texpand>
export type TournamentInfosResponse<Texpand = unknown> = Required<TournamentInfosRecord> & BaseSystemFields<Texpand>
export type TournamentPhasesResponse<Texpand = unknown> = Required<TournamentPhasesRecord> & BaseSystemFields<Texpand>
export type TournamentsResponse<Tdivision_rotation_pattern = unknown, Tdivisions = unknown, Ttiebreak_rules = unknown, Texpand = unknown> = Required<TournamentsRecord<Tdivision_rotation_pattern, Tdivisions, Ttiebreak_rules>> & BaseSystemFields<Texpand>
export type UsersResponse<Texpand = unknown> = Required<UsersRecord> & AuthSystemFields<Texpand>

// Types containing all Records and Responses, useful for creating typing helper functions

export type CollectionRecords = {
	_authOrigins: AuthoriginsRecord
	_externalAuths: ExternalauthsRecord
	_mfas: MfasRecord
	_otps: OtpsRecord
	_superusers: SuperusersRecord
	config: ConfigRecord
	discgolf_course: DiscgolfCourseRecord
	discgolf_infos: DiscgolfInfosRecord
	feedback: FeedbackRecord
	foods: FoodsRecord
	helperjobs: HelperjobsRecord
	helperjobs_view: HelperjobsViewRecord
	images: ImagesRecord
	items: ItemsRecord
	jingles: JinglesRecord
	live_scores: LiveScoresRecord
	locations: LocationsRecord
	lost_item_claims: LostItemClaimsRecord
	lost_items: LostItemsRecord
	matchups: MatchupsRecord
	notifications: NotificationsRecord
	orders: OrdersRecord
	page_views: PageViewsRecord
	players: PlayersRecord
	pool_elements: PoolElementsRecord
	pool_fixtures: PoolFixturesRecord
	pools: PoolsRecord
	requests_for_booker_role: RequestsForBookerRoleRecord
	roles: RolesRecord
	settlement_overview: SettlementOverviewRecord
	shotracer: ShotracerRecord
	slots: SlotsRecord
	slotted_matchups: SlottedMatchupsRecord
	spirit: SpiritRecord
	stats_playlists: StatsPlaylistsRecord
	team_registrations: TeamRegistrationsRecord
	teams: TeamsRecord
	theme: ThemeRecord
	timelines: TimelinesRecord
	tournament_infos: TournamentInfosRecord
	tournament_phases: TournamentPhasesRecord
	tournaments: TournamentsRecord
	users: UsersRecord
}

export type CollectionResponses = {
	_authOrigins: AuthoriginsResponse
	_externalAuths: ExternalauthsResponse
	_mfas: MfasResponse
	_otps: OtpsResponse
	_superusers: SuperusersResponse
	config: ConfigResponse
	discgolf_course: DiscgolfCourseResponse
	discgolf_infos: DiscgolfInfosResponse
	feedback: FeedbackResponse
	foods: FoodsResponse
	helperjobs: HelperjobsResponse
	helperjobs_view: HelperjobsViewResponse
	images: ImagesResponse
	items: ItemsResponse
	jingles: JinglesResponse
	live_scores: LiveScoresResponse
	locations: LocationsResponse
	lost_item_claims: LostItemClaimsResponse
	lost_items: LostItemsResponse
	matchups: MatchupsResponse
	notifications: NotificationsResponse
	orders: OrdersResponse
	page_views: PageViewsResponse
	players: PlayersResponse
	pool_elements: PoolElementsResponse
	pool_fixtures: PoolFixturesResponse
	pools: PoolsResponse
	requests_for_booker_role: RequestsForBookerRoleResponse
	roles: RolesResponse
	settlement_overview: SettlementOverviewResponse
	shotracer: ShotracerResponse
	slots: SlotsResponse
	slotted_matchups: SlottedMatchupsResponse
	spirit: SpiritResponse
	stats_playlists: StatsPlaylistsResponse
	team_registrations: TeamRegistrationsResponse
	teams: TeamsResponse
	theme: ThemeResponse
	timelines: TimelinesResponse
	tournament_infos: TournamentInfosResponse
	tournament_phases: TournamentPhasesResponse
	tournaments: TournamentsResponse
	users: UsersResponse
}

// Type for usage with type asserted PocketBase instance
// https://github.com/pocketbase/js-sdk#specify-typescript-definitions

export type TypedPocketBase = PocketBase & {
	collection(idOrName: '_authOrigins'): RecordService<AuthoriginsResponse>
	collection(idOrName: '_externalAuths'): RecordService<ExternalauthsResponse>
	collection(idOrName: '_mfas'): RecordService<MfasResponse>
	collection(idOrName: '_otps'): RecordService<OtpsResponse>
	collection(idOrName: '_superusers'): RecordService<SuperusersResponse>
	collection(idOrName: 'config'): RecordService<ConfigResponse>
	collection(idOrName: 'discgolf_course'): RecordService<DiscgolfCourseResponse>
	collection(idOrName: 'discgolf_infos'): RecordService<DiscgolfInfosResponse>
	collection(idOrName: 'feedback'): RecordService<FeedbackResponse>
	collection(idOrName: 'foods'): RecordService<FoodsResponse>
	collection(idOrName: 'helperjobs'): RecordService<HelperjobsResponse>
	collection(idOrName: 'helperjobs_view'): RecordService<HelperjobsViewResponse>
	collection(idOrName: 'images'): RecordService<ImagesResponse>
	collection(idOrName: 'items'): RecordService<ItemsResponse>
	collection(idOrName: 'jingles'): RecordService<JinglesResponse>
	collection(idOrName: 'live_scores'): RecordService<LiveScoresResponse>
	collection(idOrName: 'locations'): RecordService<LocationsResponse>
	collection(idOrName: 'lost_item_claims'): RecordService<LostItemClaimsResponse>
	collection(idOrName: 'lost_items'): RecordService<LostItemsResponse>
	collection(idOrName: 'matchups'): RecordService<MatchupsResponse>
	collection(idOrName: 'notifications'): RecordService<NotificationsResponse>
	collection(idOrName: 'orders'): RecordService<OrdersResponse>
	collection(idOrName: 'page_views'): RecordService<PageViewsResponse>
	collection(idOrName: 'players'): RecordService<PlayersResponse>
	collection(idOrName: 'pool_elements'): RecordService<PoolElementsResponse>
	collection(idOrName: 'pool_fixtures'): RecordService<PoolFixturesResponse>
	collection(idOrName: 'pools'): RecordService<PoolsResponse>
	collection(idOrName: 'requests_for_booker_role'): RecordService<RequestsForBookerRoleResponse>
	collection(idOrName: 'roles'): RecordService<RolesResponse>
	collection(idOrName: 'settlement_overview'): RecordService<SettlementOverviewResponse>
	collection(idOrName: 'shotracer'): RecordService<ShotracerResponse>
	collection(idOrName: 'slots'): RecordService<SlotsResponse>
	collection(idOrName: 'slotted_matchups'): RecordService<SlottedMatchupsResponse>
	collection(idOrName: 'spirit'): RecordService<SpiritResponse>
	collection(idOrName: 'stats_playlists'): RecordService<StatsPlaylistsResponse>
	collection(idOrName: 'team_registrations'): RecordService<TeamRegistrationsResponse>
	collection(idOrName: 'teams'): RecordService<TeamsResponse>
	collection(idOrName: 'theme'): RecordService<ThemeResponse>
	collection(idOrName: 'timelines'): RecordService<TimelinesResponse>
	collection(idOrName: 'tournament_infos'): RecordService<TournamentInfosResponse>
	collection(idOrName: 'tournament_phases'): RecordService<TournamentPhasesResponse>
	collection(idOrName: 'tournaments'): RecordService<TournamentsResponse>
	collection(idOrName: 'users'): RecordService<UsersResponse>
}
